import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class GenerateButton extends Component {
  constructor(props) {
    super(props);
    this.handleGenerateClick = this.handleGenerateClick.bind(this);
  }

  handleGenerateClick() {
    const {provider, partType} = this.props;

    if (provider && partType) {
      this.props.generateProviderStockOrder(provider, partType);
    }
  }

  render() {
    const {loading, consulted, count} = this.props;

    if (loading || !consulted || (count > 0)) {
      return null;
    }

    return (
      <Button
        primary
        type='button'
        onClick={this.handleGenerateClick}>
          GENERAR SUGERIDO
      </Button>
    );
  }
}

const mapStateToProps = (state) => {
  const {filteredOrders = [], loadingSuggestions, generating} = state.providerStockOrders;

  return {
    'loading': loadingSuggestions || generating,
    'consulted': state.providerStockOrders.consulted,
    'count': filteredOrders.length,
    'provider': state.providerStockOrders.provider,
    'partType': state.providerStockOrders.partType,
  };
};

const {
  generateProviderStockOrder,
} = Actions;

export default connect(mapStateToProps, {
  generateProviderStockOrder,
})(GenerateButton);
